import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModelVariant, TeamVariant } from 'src/app/shared/models/type-list';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-reassign-work-dialog',
  imports: [CommonModule, MatDialogModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatSelectModule, MatButtonModule,
              MatCardModule],
  templateUrl: './reassign-work-dialog.component.html',
  styleUrl: './reassign-work-dialog.component.scss',
  standalone: true
})

export class ReassignWorkDialogComponent implements OnInit {
  fg_TransferVariant: FormGroup = <FormGroup>{};
  variantList: TeamVariant[] = [];
  baseVariantID: number = 0;
  reassignVariant: TeamVariant = <TeamVariant>{};


  constructor(
    public dialogRef: MatDialogRef<ReassignWorkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inData: any,
    private fb: FormBuilder,
    private dialog: MatDialog
  ){}

  ngOnInit(): void {
    console.log(this.inData)
    this.variantList = this.inData.variants? this.inData.variants: [];
    this.variantList.push({ variant_id: -1, variant_name: '< Unselect Variant >'})
    this.baseVariantID = this.inData.base_variant_id? this.inData.base_variant_id: 0;

    this.fg_TransferVariant = this.fb.group({
      f_ReassignVariant: new FormControl([])
    });

    this.fg_TransferVariant.valueChanges.subscribe((value)=>{
      this.reassignVariant = value.f_ReassignVariant;
      if (this.reassignVariant.variant_id == -1){
        this.reassignVariant = <TeamVariant>{};
        this.fg_TransferVariant.get('f_ReassignVariant')?.setValue('');
      }
    });  
  }

  onNoClick():void{
    this.dialogRef.close()
  }

  onSubmit(){
    let returnData: any = { variant: this.reassignVariant };
    this.dialogRef.close(returnData);
  }

}
